import { useState, useEffect, useRef } from 'react';
import bem from '../../utils/bem';
import Button from '../../Components/Atoms/Button';
import Icon from '../../Components/Atoms/Icon/Icon';
import GlobalSearchDynamic from '../../Components/Molecules/GlobalSearchDynamic';
import useWindowWidth from '../../hooks/useWindowWidth';

const GlobalSearchMegaMenu = () => {
  const [searchOpened, setSearchOpened] = useState(false);
  const globalSearchMegaMenuElement = useRef(null);
  const { breakpoint } = useWindowWidth();

  const baseClass = 'global-search-mega-menu';

  useEffect(() => {
    const handler = (event) => {
      if (
        globalSearchMegaMenuElement.current &&
        !globalSearchMegaMenuElement.current.contains(event.target)
      ) {
        setSearchOpened(false);
      }
    };

    document.addEventListener('click', handler, true);

    return () => {
      document.removeEventListener('click', handler);
    };
  }, []);

  useEffect(() => {
    if (searchOpened) {
      const searchInput = globalSearchMegaMenuElement.current.querySelector(
        '#field-globalSearch',
      );

      searchInput.focus();
    }
  }, [searchOpened]);

  const closeSearchButton = breakpoint.isDesktop ? (
    'Close'
  ) : (
    <Icon iconName="chevron" />
  );

  const openSearchButton = (
    <>
      <Icon iconName="search-thick" />
      <span className="visually-hidden">Open search</span>
    </>
  );

  const escapeKeyDownEvent = () => {
    if (searchOpened) {
      setSearchOpened(false);

      const searchOpenButton =
        globalSearchMegaMenuElement.current.querySelector(
          '.global-search-mega-menu__button',
        );

      if (!searchOpenButton) {
        return;
      }

      searchOpenButton.focus();
    }
  };

  return (
    <div
      className={bem(baseClass, [searchOpened ? 'search-open' : ''], '')}
      ref={globalSearchMegaMenuElement}
    >
      <div
        className={bem('search-wrap', [], baseClass, [
          searchOpened ? '' : 'hidden',
        ])}
        onKeyDown={(event) => {
          if (event.keyCode === window.ct.keyCodes.esc) {
            escapeKeyDownEvent();
          }
        }}
      >
        <GlobalSearchDynamic />
      </div>
      <Button
        onClick={() => setSearchOpened(!searchOpened)}
        block="button"
        base={baseClass}
        extra={['btn-icon']}
      >
        {searchOpened ? closeSearchButton : openSearchButton}
      </Button>
    </div>
  );
};

export default GlobalSearchMegaMenu;
